/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Normal
 *
 * 2 = Priority
 *
 * 3 = CollectionAndDelivery
 *
 * 4 = Waiting
 */
export enum ValetingStatus {
  Normal = 1,
  Priority = 2,
  CollectionAndDelivery = 3,
  Waiting = 4,
}
